export interface IFetchLimit {
  page: number;
  shopData: any[];
}

export const fetchLimitInitialState = {
  page: 1,
  shopData: [],
};
